module.exports = __webpack_public_path__ + "img/ic_dlf@2x (1).a5fa3908.png";